declare namespace $ {

	type $shm_file_drop__files_shm_showcase_demo_file_drop_1 = $mol_type_enforce<
		ReturnType< $shm_showcase_demo_file_drop['files'] >
		,
		ReturnType< $shm_file_drop['files'] >
	>
	type $mol_text__text_shm_showcase_demo_file_drop_2 = $mol_type_enforce<
		ReturnType< $shm_showcase_demo_file_drop['selected'] >
		,
		ReturnType< $mol_text['text'] >
	>
	export class $shm_showcase_demo_file_drop extends $mol_list {
		files( next?: readonly(File)[] ): readonly(File)[]
		Input( ): $shm_file_drop
		selected( ): string
		Selected( ): $mol_text
		rows( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=drop.view.tree.d.ts.map